import { render } from "./ManagementContent.vue?vue&type=template&id=4ab3ffc1&scoped=true"
import script from "./ManagementContent.vue?vue&type=script&lang=js"
export * from "./ManagementContent.vue?vue&type=script&lang=js"

import "./ManagementContent.vue?vue&type=style&index=0&id=4ab3ffc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab3ffc1"]])

export default __exports__